"use client";

import React from "react";
import { CodeCanvas } from "./code-canvas";
import { usePathname } from "next/navigation";
import { isConversionPage } from "@/lib/utils/conversion-pages";

export const CodeBackground = () => {
  const pathname = usePathname();
  const isAdminPage = pathname.startsWith("/sachinsharma/official/adminpanel");

  if (isAdminPage || isConversionPage(pathname)) return null;

  return (
    <div className="fixed inset-0 z-0 pointer-events-none h-full w-full overflow-hidden">
      {/* Code Nebula Background */}
      <CodeCanvas />

      {/* Radial Gradient Overlay for readability */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(0,0,0,0)_0%,rgba(var(--background),1)_80%)]" />
    </div>
  );
};
